import axios from 'axios';
import { nullSafe } from 'Utility/globalMethods'

export const getLanguages = (locale) =>
  axios
    .get(`${process.env.CMS_URL}/translations/lang-${locale}.jsonx`)
    .then((response) => {
      const safeResponse = nullSafe(() => response.data, '');
      if (!safeResponse) throw new Error('Data is incorrect');
      return safeResponse;
    })
    .catch(() => {
      throw new Error('Missing data');
    });